export type MedicationStatus = 'Active' | 'Inactive';

export function getMedicationStatus(isActive: boolean): MedicationStatus {
  return isActive ? 'Active' : 'Inactive';
}
